var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-wrap"},[_c('van-tabs',{attrs:{"color":"#3e78f7"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{attrs:{"title":"问题墙"}},[_c('wtq')],1),_c('van-tab',{attrs:{"title":"回音壁"}},[_c('hyb')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }